import { Money } from '@ap/interface-bspc-core';
import { ExtraAsset } from '@ap/ap-interface-apix-hypotheken-berekening';

export class ExtraAssetBuilder {
    private ownProperty: boolean;
    private sellingPrice?: Money;
    private mortgageAmount?: Money;
    private ownMoney: boolean;
    private ownMoneyAmount?: Money;

    withOwnProperty(ownProperty: boolean): this {
        this.ownProperty = ownProperty;
        return this;
    }

    withSellingPrice(sellingPrice: Money): this {
        this.sellingPrice = sellingPrice;
        return this;
    }

    withMortgageAmount(mortgageAmount: Money): this {
        this.mortgageAmount = mortgageAmount;
        return this;
    }

    withOwnMoney(ownMoney: boolean): this {
        this.ownMoney = ownMoney;
        return this;
    }

    withOwnMoneyAmount(ownMoneyAmount: Money): this {
        this.ownMoneyAmount = ownMoneyAmount;
        return this;
    }

    build(): ExtraAsset {
        return {
            own_property: this.ownProperty,
            selling_price: this.sellingPrice,
            mortgage_amount: this.mortgageAmount,
            own_money: this.ownMoney,
            own_money_amount: this.ownMoneyAmount
        } as ExtraAsset;
    }
}
